<template>
  <div v-if="loading" class="page-center">
    <div class="page-center-box text-center">
      <ui-loading-page />
    </div>
  </div>
  <div v-else>
    <div class="d-flex align-items-center justify-content-between">
      <div class="me-2">
        <RouterLink
          class="btn btn-ghost btn-back"
          :to="'/leasings/' + route.params.id"
        >
          <LeftIcon class="icon" />
        </RouterLink>
      </div>
      <div class="flex-grow-1 page-title">
        Согласие на обработку персональных данных
      </div>
      <div class="ms-2" style="width: 36px"></div>
    </div>

    <div class="hr mb-4"></div>

    <div v-if="status > 0 && status < 10" class="row">
      <div class="col-md-8 col-lg-6">
        <div>
          <div class="login-alert p-3 text-center mb-3">
            <div class="text-primary">Внимание!</div>
            <span
              >Документ принят! После проверки с вами свяжется менеджер.</span
            >
          </div>
        </div>
      </div>
    </div>

    <PDConsentEdit
      :data="data"
      :citizenshipList="citizenshipList"
      :uid="RID"
      :status="status"
    />
  </div>
</template>


<script setup>
import LeftIcon from "@/assets/svg/left.vue";
import { useRoute } from "vue-router";

import { onMounted, ref, onBeforeUnmount } from "vue";
import { postApi } from "@/run";

import PDConsentEdit from "./PDConsentEdit/index.vue";

// Получаем текущий маршрут
const route = useRoute();

const loading = ref(true);

const data = ref({});
const citizenshipList = ref([]);
const RID = ref(null);
const status = ref(null);

onMounted(() => {
  postApi("/leasing/personal-data-consent", {
    id: route.params.id,
  })
    .then((response) => {
      if (response.error) {
        error.value = response.error;
      }

      if (response?.dirSopd) {
        let ReqData = response.dirSopd?.ReqData
          ? JSON.parse(response.dirSopd.ReqData)
          : {};
        let ReqResponce = response.dirSopd?.ReqResponce
          ? JSON.parse(response.dirSopd.ReqResponce)
          : {};

        RID.value = response.dirSopd?.RID;
        status.value = response.dirSopd?.Status
          ? Number(response.dirSopd.Status)
          : 0;

        citizenshipList.value = response.citizenshipList
          ? response.citizenshipList
          : [];

        data.value = { ...ReqData, ...ReqResponce };
      }
    })
    .finally(() => {
      loading.value = false;
    });
});
</script>